import { render, staticRenderFns } from "./FlexibleDetailTab1.vue?vue&type=template&id=bd36b4b2&scoped=true"
import script from "./FlexibleDetailTab1.vue?vue&type=script&lang=js"
export * from "./FlexibleDetailTab1.vue?vue&type=script&lang=js"
import style0 from "./FlexibleDetailTab1.vue?vue&type=style&index=0&id=bd36b4b2&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./FlexibleDetailTab1.vue?vue&type=style&index=1&id=bd36b4b2&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd36b4b2",
  null
  
)

export default component.exports